<template>
    <div class="sala">
      <span v-if="debug === 'true' || debug === true">{{version}}</span>
        <div class="cita"
            v-if="horarioClinica !== undefined"
            @click.prevent="consultarDetalle(horarioClinica)"
            :style="ancho+color+tamanio"
            v-b-tooltip.hover.left
            :title="($debug?'ID:' + JSON.stringify(horarioClinica)+'-':'')
            + ' Sillón: ' + horarioClinica.sillon
            +' Rango: ' + $formatoFecha(horarioClinica.fechaInicio) + ' al ' +$formatoFecha(horarioClinica.fechaFin)
            +' Horario: ' + $formatoHora(horarioClinica.horaInicio) + ' a ' +$formatoHora(horarioClinica.horaFin)">
        </div>
  
    </div>
</template>

<script>
    export default {
        props: {
            numeroSalas: {
                type: Number,
                default: -1
            },
            horarioClinica: {
                type: Object
            }
        },
        computed: {
            ancho() {
                const num = this.numeroSalas - 4;

                if (this.numeroSalas <= 4) {
                    return "width:20px;";
                } else if (this.numeroSalas <= 6) {
                    return "width:"  + (20/num)+"px;";
                } else {
                    return "width:"  + (20/num)+"px; color:black;";
                }

            }
        },
        data: () => ({
            version: process.env.VUE_APP_ENV_VERSION,
            debug: false,
            color: "background:rgb(255, 102, 0);",
            tamanio: "height: 26.75px;"
        }),
        created() {
            this.validarCita(this.horarioClinica);
            this.debug = this.$localStorageService.getDebug();
        },
        methods: {
            consultarDetalle(horarioClinica) {
                this.$emit("consultarDetalle", horarioClinica);
            },
            validarCita(val) {
                if (val !== undefined) {
                    this.color = "background:rgb(255, 102, 0);";
                    this.tamanio = "height: 26.75px;";

                    const fc1 = new Date("2014-02-27T" + val.horaInicioCasilla);
                    const fc2 = new Date("2014-02-27T" + val.horaFinCasilla);
                    const difMilisegundos = Math.abs(fc2 - fc1);
                    const difMinutos = Math.floor(difMilisegundos / 1000 / 60);
                    let vecesRepetir = Math.abs(difMinutos / 15);

                    if (vecesRepetir === 0) {
                        vecesRepetir++;
                    }
                    const tamanio = 26.75 * vecesRepetir;
                    // const tamanio = 26.75 * vecesRepetir - 53.5;
                    this.tamanio = "height: " + tamanio + "px;";
                    this.color = val.color ? "background:" + val.color + " ;" : "background: #52D017;";
                }
            }
        },
        watch: {
            horarioClinica() {
                this.validarCita(this.horarioClinica);
            }
        }
    };
</script>

<style scoped>
    @import '~vue-context/dist/css/vue-context.css';

    .sala {
        /*min-width: 35px;*/
        height: 20px;
        font-size: small;
        font-weight: bolder;
    }

    .fa {
        font-size: 13px !important;
        margin-top: 10px !important;
    }

    .md-icon-button {
        width: 14px !important;
        min-width: 14px !important;
    ;
        height: 14px !important;
    ;
        margin: 0px !important;
    ;
        font-size: 11px !important;
    ;
    }

    .cita {
        position: absolute;
        padding: 2px;
        box-shadow: 2px 3px #b4afafad;
        margin-top: -4px;
        display: block;
        width: 20px;
        font-size: 0.4em;
        margin-left: 2px;
        z-index: 6;
        border-radius: 7px;
        border: solid 1px black;
        font-weight: bold;
        color: white;
    }

    .body-sala {
        position: absolute;
        width: 18px;
        left: 0px;
        top: 7px;
    }
</style>